import { IParkingTypeModel } from '@aggregator/core';

export interface IParkingLocation {
  id: string;
  location: ILocation;
  totalSpots: number;
  freeSpotsCount: number;
}

export interface IParkingFilterParams {
  categoryIds: string[];
  operatorIds: string[];
  typeIds: string[];
  statuses: StatusEnum;
  dateFrom: string;
  dateTo: string;
}

export interface IParkingDetail {
  id: string;
  name: string;
  type: IParkingTypeModel;
  address: string;
  category: INestedElement<string, string>;
  operator: IOperator;
  workingHours: { open: string; close: string };
  status: StatusEnum;
  photoUrl: string;
  totalSpots: number;
  freeSpotsCount: number;
  tarif: ITarif[];
}

export interface IParkingTotalData extends IParkingLocation, IParkingDetail {}

export interface ITarif {
  id: string;
  operatorId: string;
  name: string;
  description: string;
}

export interface ILocation {
  x: number;
  y: number;
}

export interface INestedElement<T, K> {
  id: T;
  name: K;
  description?: K;
}

export interface IOperator {
  id: string;
  name: string;
  address: string;
  isActive: boolean;
  contactEmail: string;
  contactPhone: string;
  contactPerson: string;
}

export enum StatusEnum {
  All = '',
  Active = 0,
  InActive = 1,
  Maintenance = 2,
}

export const StatusNameEnum = {
  [StatusEnum.All]: 'Все',
  [StatusEnum.Active]: 'Активный',
  [StatusEnum.InActive]: 'Неактивный',
  [StatusEnum.Maintenance]: 'Техническое обслуживание',
};

export enum MapProviderTypeEnum {
  GIS2,
  Google,
  OSM,
}

export const MapLayers = {
  [MapProviderTypeEnum.Google]: {
    url: 'http://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    options: {
      maxZoom: 20,
      attribution: '',
      className: 'grayscale-darken',
    },
  },
  [MapProviderTypeEnum.GIS2]: {
    url: 'https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1.1&r=g&s=1024&ts=online',
    options: {
      maxZoom: 18,
      attribution: '',
      className: 'grayscale-darken',
    },
  },
  [MapProviderTypeEnum.OSM]: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    options: {
      maxZoom: 19,
      attribution: '',
      className: 'grayscale-darken',
    },
  },
};

export interface IParkingHistoryHub {
  parkingId: string;
  eventType: number;
  eventTimestamp: string;
  freeSpotsCount: number;
  stateLicencePlate: string;
}
